import gm1 from "../assets/img/globala_mal_2/1.svg"
import gm2 from "../assets/img/globala_mal_2/2.svg"
import gm3 from "../assets/img/globala_mal_2/3.svg"
import gm4 from "../assets/img/globala_mal_2/4.svg"
import gm5 from "../assets/img/globala_mal_2/5.svg"
import gm6 from "../assets/img/globala_mal_2/6.svg"
import gm7 from "../assets/img/globala_mal_2/7.svg"
import gm8 from "../assets/img/globala_mal_2/8.svg"
import gm9 from "../assets/img/globala_mal_2/9.svg"
import gm10 from "../assets/img/globala_mal_2/10.svg"
import gm11 from "../assets/img/globala_mal_2/11.svg"
import gm12 from "../assets/img/globala_mal_2/12.svg"
import gm13 from "../assets/img/globala_mal_2/13.svg"
import gm14 from "../assets/img/globala_mal_2/14.svg"
import gm15 from "../assets/img/globala_mal_2/15.svg"
import gm16 from "../assets/img/globala_mal_2/16.svg"
import gm17 from "../assets/img/globala_mal_2/17.svg"

export default [
    gm1,
    gm2,
    gm3,
    gm4,
    gm5,
    gm6,
    gm7,
    gm8,
    gm9,
    gm10,
    gm11,
    gm12,
    gm13,
    gm14,
    gm15,
    gm16,
    gm17,
]
